import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    "& .MuiButtonBase-root": {
      textTransform: "none",
      fontSize: theme.fontSizes.lg,
      color: theme.colors.obsidian,
      letterSpacing: "0",
      opacity: 0.6,
      lineHeight: "24px",
      "&:not(:first-child)": {
        marginLeft: 40,

        [theme.breakpoints.down("desktop")]: {
          marginLeft: 10,
        },
      },
    },

    "& .Mui-selected": {
      opacity: 1,
      color: `${theme.colors.obsidian} !important`,
    },
    "& .MuiTabs-indicator": {
      height: 4,
    },
  },

  containerRtl: {
    width: "100%",
    "& .MuiButtonBase-root": {
      textTransform: "none",
      fontSize: theme.fontSizes.lg,
      color: theme.colors.obsidian,
      letterSpacing: "0",
      opacity: 0.6,
      lineHeight: "24px",
      "&:not(:first-child)": {
        marginRight: 40,

        [theme.breakpoints.down("desktop")]: {
          marginRight: 10,
        },
      },
    },

    "& .Mui-selected": {
      opacity: 1,
      color: `${theme.colors.obsidian} !important`,
    },
    "& .MuiTabs-indicator": {
      height: 4,
    },
  },
}));

export default useStyles;
